import styled from 'styled-components';
import { ServiceStatus } from '../../../types/enums';

interface IContainerProps {
  status: ServiceStatus;
  isBorder?: boolean;
}

interface IContentProps {
  isOpenHistory: boolean;
}

export const Container = styled.div<IContainerProps>`
  width: auto;
  margin: 0.5rem;

  ${({ isBorder, theme, status }) =>
    isBorder === true &&
    `
    border: solid 2px;
    border-color: ${
      status === ServiceStatus.UNPAID ? theme.colors.gray_275 : theme.colors.tertiary_500
    } ;
    border-radius: 10px;
    padding: 1rem;
  `}

  .buttons-request {
    display: flex;
    width: 90%;
    justify-content: flex-end;
    margin-top: 2rem;
    border-top: 1px solid ${({ theme }) => theme.colors.tertiary_500};

    .baseButtonRequest {
      width: 20%;
      height: 1.8rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 2rem;
      font-weight: 300;
      transition: all linear 300ms;
      font-size: 1.2rem;
      margin-top: 0.5rem;
      border: solid 1px ${({ theme }) => theme.colors.secondary};
      color: ${({ theme }) => theme.colors.background_white};
      background: ${({ theme }) => theme.colors.secondary};

      &:hover {
        opacity: 0.5;
      }
    }
  }

  .buttons {
    border-top: 1px solid ${({ theme }) => theme.colors.tertiary_500};
    margin-top: 2rem;

    .buttons-demand {
      display: flex;
      margin: auto;
      width: 95%;
      justify-content: space-between;
      align-items: center;
      padding: 1rem;

      .contentButtonDemand {
        display: flex;
        width: 100%;
        gap: 1rem;
        justify-content: end;

        .baseButtonDemand {
          width: 12rem;
          height: 1.8rem;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 2rem;

          font-weight: 300;
          transition: all linear 300ms;
          font-size: 1.2rem;
          transition: opacity 0, 5s;
          &:hover {
            opacity: 0.6;
          }
        }

        .baseButtonDemand:nth-child(2) {
          border: solid 1px ${({ theme }) => theme.colors.secondary};
          color: ${({ theme }) => theme.colors.background_white};
          background: ${({ theme }) => theme.colors.secondary};
        }

        .baseButtonDemand:nth-child(2):hover {
          color: ${({ theme }) => theme.colors.background_white};
          background-color: ${({ theme }) => theme.colors.tertiary_500};
          border: none;
          opacity: 1;
        }

        .baseButtonDemand:nth-child(1) {
          color: ${({ theme }) => theme.colors.primary};
          background: transparent;
          border: solid 1px ${({ theme }) => theme.colors.tertiary_500};
          text-decoration: none;
        }

        .baseButtonDemand:nth-child(1):hover {
          color: ${({ theme }) => theme.colors.background_white};
          background-color: ${({ theme }) => theme.colors.tertiary_500};
          opacity: 1;
        }
      }

      .button-back-historic {
        width: 12rem;
        height: 1.8rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 2rem;
        font-weight: 300;
        transition: all linear 300ms;
        font-size: 1.2rem;
        margin-top: 0.5rem;
        transition: opacity 0, 5s;
        border: solid 1px ${({ theme }) => theme.colors.secondary};
        color: ${({ theme }) => theme.colors.background_white};
        background: ${({ theme }) => theme.colors.secondary};

        &:hover {
          opacity: 0.5;
        }
      }
    }

    .baseButtonRequest {
      width: 12rem;
      height: 1.8rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 2rem;
      font-weight: 300;
      transition: all linear 300ms;
      font-size: 1.2rem;
      margin-top: 0.5rem;
      transition: opacity 0, 5s;
      border: solid 1px ${({ theme }) => theme.colors.secondary};
      color: ${({ theme }) => theme.colors.background_white};
      background: ${({ theme }) => theme.colors.secondary};

      &:hover {
        opacity: 0.6;
      }
    }
  }

  .divAttachments {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-height: 8rem;
    gap: 0.6rem;
    padding-top: 0.65rem;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 8px;
      background-color: ${({ theme }) => theme.colors.background_white};
      border-radius: 10px;
    }

    ::-webkit-scrollbar:horizontal {
      height: 5px;
    }

    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-horizontal {
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:horizontal {
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      border-radius: 10px;
    }
  }

  .buton-open-historic {
    margin: 1rem 0 0 1rem;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    background: none;
    padding: 0;
    border: 0;
    transition: opacity 0.5s;
    color: ${({ theme }) => theme.colors.tertiary_500};

    :hover {
      opacity: 0.7;
      cursor: pointer;
    }

    svg {
      fill: ${({ theme }) => theme.colors.tertiary_500};
      color: ${({ theme }) => theme.colors.tertiary_500};
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 0.5rem;
    }

    .iconClose {
      max-width: 1.2rem;
      max-height: 1.2rem;
    }
  }

  div {
    .text-anotation {
      max-height: 6rem;
      overflow-y: auto;
      color: ${({ theme }) => theme.colors.text_gray};

      ::-webkit-scrollbar {
        width: 8px;
        background-color: ${({ theme }) => theme.colors.background_white};
        border-radius: 10px;
      }

      ::-webkit-scrollbar:horizontal {
        height: 5px;
      }

      ::-webkit-scrollbar-track,
      ::-webkit-scrollbar-track-horizontal {
        border-radius: 10px;
      }

      ::-webkit-scrollbar-thumb,
      ::-webkit-scrollbar-thumb:horizontal {
        background-color: ${({ theme }) => theme.colors.tertiary_500};
        border-radius: 10px;
      }
    }
  }

  .icon-buton {
    display: flex;
    align-items: center;

    p {
      max-width: 70%;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.secondary};
    }

    .text-payment {
      color: ${({ theme }) => theme.colors.primary};
    }

    button {
      display: flex;
      align-items: center;
      background: none;
      margin: 0;
      padding: 0;
      border: 0;

      transition: opacity 0.5s;
      :hover {
        opacity: 0.7;
        cursor: pointer;
      }

      svg {
        color: ${({ theme }) => theme.colors.tertiary_500};
        width: 1.2rem;
        height: 1.2rem;
        margin-left: 0.5rem;
      }
    }
  }

  .btnHistoric {
    color: ${({ theme }) => theme.colors.tertiary_500};
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    font-weight: 300;
    gap: 0.5rem;
    text-transform: none;
    border-radius: 1rem;
    margin: 0.5rem 0;

    svg {
      fill: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  .containerDataSolicitation {
    display: flex;
    align-items: flex-start;
    position: relative;
  }

  @media (max-width: 690px) {
    .containerDataSolicitation {
      flex-direction: column;
      gap: 1rem;
      max-height: 25rem;
      overflow-y: scroll;
      overflow-x: hidden;
    }

    .buttons .buttons-demand:has(.column-align) {
      width: 100%;
      flex-direction: column;
      gap: 1rem;
      padding: 1rem 0 0 0;

      .column-align {
        justify-content: center;
      }
    }
  }

  @media (max-width: 360px) {
    .buttons .buttons-demand:not(.column-align) {
      width: 100%;
      flex-direction: column;
      gap: 1rem;
      padding: 1rem 0 0 0;
    }
  }
`;

export const Header = styled.header<IContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-height: 4rem;
  width: 100%;

  .icon-header {
    width: 4rem;
    height: 4rem;
    color: ${({ status, theme }) =>
      status === ServiceStatus.CANCELED ? theme.colors.black : theme.colors.secondary};
  }

  .containerGrid {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .containerStatus {
      display: flex;
      align-items: center;
      .protocol {
        color: ${({ theme }) => theme.colors.text};
        font-weight: 400;
      }
    }
    .createdAt {
      color: ${({ theme }) => theme.colors.secondary};
      font-weight: 400;
      span {
        color: ${({ theme }) => theme.colors.text};
        font-weight: 400;
      }
    }
  }

  .title {
    font-weight: 700;
    color: ${({ status, theme }) =>
      status === ServiceStatus.CANCELED ? theme.colors.black : theme.colors.secondary};
    font-size: 1.5rem;
  }

  .statusCard {
    font-weight: 400;
    color: ${({ status, theme }) =>
      status === ServiceStatus.CANCELED ? theme.colors.black : theme.colors.secondary};
    font-size: 1rem;

    /* variacao de status cancelado */
    &.canceled {
      color: ${({ theme }) => theme.colors.text_gray};
    }

    /* variacao de status aprovado */
    &.conclused {
      color: ${({ theme }) => theme.colors.primary};
    }

    /* variacao de status pendente */
    &.pending {
      color: ${({ theme }) => theme.colors.error};
    }
    &.unpaid {
      color: ${({ theme }) => theme.colors.error};
    }
  }

  p {
    margin-left: 1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .container-header {
    display: flex;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  p {
    text-overflow: ellipsis;
  }

  .container-header-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;

    .icon-title-status {
      display: flex;
      width: 50%;

      svg {
        width: 4rem;
      }
    }

    .deadline {
      width: 40%;
    }
  }

  @media (max-width: 700px) {
    .container-header-info {
      width: 90%;
      margin: 1 auto;
      display: flex;
      justify-content: space-between;
    }

    .container-header-info h1 {
      font-size: 1.2rem;
    }

    .container-header-info p {
      font-size: 1.2rem;
      line-height: 1.4;
    }

    .container-header-info button,
    .container-header-info a {
      font-size: 0.8rem;
      padding: 8px 12px;
    }

    body {
      padding: 10px;
    }

    .container-header-info img {
      max-width: 100%;
      height: auto;
    }

    .deadline p {
      text-overflow: ellipsis;
    }
  }

  svg {
    color: ${({ status, theme }) =>
      status === ServiceStatus.CANCELED ? theme.colors.black : theme.colors.secondary};
    font-size: 24px;
  }

  .containerButton {
    width: auto;
    display: flex;
    justify-content: end;
  }

  @media (max-width: 950px) {
    .container-header-info .icon-title-status .icon-header {
      width: 3rem;
      height: 3rem;
    }

    .container-header-info .address {
      display: none;
    }
  }

  @media (max-width: 500px) {
    .container-header-info .icon-title-status .icon-header {
      display: none;
    }

    .container-header-info .icon-title-status .containerGrid p {
      margin-left: 0px;
    }

    .container-header-info .specialty {
      display: none;
    }

    .container-header-info .icon-title-status {
      width: 55%;
    }

    .container-header-info .deadline {
      width: 45%;
    }

    .container-header .icon-header {
      display: none;
    }

    .container-header .containerGrid p {
      margin-left: 0px;
    }

    .title {
      font-size: 1.2rem;
    }

    .statusCard {
      font-size: 1rem;
    }
  }

  @media (max-width: 350px) {
    .container-header-info {
      width: 85%;
    }

    .container-header-info .icon-title-status {
      width: 55%;
    }

    .container-header-info .deadline {
      width: 45%;
    }
  }
`;

export const Content = styled.div<IContentProps>`
  display: flex;

  .contentOptionsEventSolicitations {
    width: 17%;
    margin-left: 0.5rem;
  }

  .contentItensSolicitations {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  @media (max-width: 1200px) {
    flex-direction: column;
    gap: 1rem;
    max-height: 25rem;
    overflow-y: scroll;
    overflow-x: hidden;

    .contentOptionsEventSolicitations {
      width: 100%;
      margin-left: 0;
    }

    .contentItensSolicitations {
      flex-direction: column;
      gap: 1rem;
    }
  }
`;
